<section class="mat-typography mat-body component-container">

  <p class="heading">Please select the document type <span>(* required)</span></p>

  <form [formGroup]="form">
    <mat-radio-group [formControlName]="'documentType'">
      @for (option of parsedData; track $index) {
        <mat-radio-button [value]="option">
          {{ option.label }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </form>

  @if (formValuesAsJson.documentType) {
    <div class="margin-top">
      @switch (formValuesAsJson.documentType.componentStrategy) {
        @case ('AEM_DAM') {
          @for (option of dataMap['AEM_DAM']; track trackByOrder(i, option); let i = $index) {
            @if (option.order === formValuesAsJson.documentType.order) {
              <slot name="AEM_SLOT_{{i}}">Slot AEM_SLOT_{{i}}</slot>
            }
          }
        }
        @case ('SMALL_GROUP_DOCUMENTS') {
          @for (option of dataMap['SMALL_GROUP_DOCUMENTS']; track trackByOrder(i, option); let i = $index) {
            @if (option.order === formValuesAsJson.documentType.order) {
              <slot name="SMALL_GROUP_{{i}}">SMALL_GROUP_{{i}}</slot>
            }
          }
        }
      }
    </div>
  }

</section>